import { render, staticRenderFns } from "./DictList.vue?vue&type=template&id=1aa056f3&scoped=true"
import script from "./DictList.vue?vue&type=script&lang=js"
export * from "./DictList.vue?vue&type=script&lang=js"
import style0 from "./DictList.vue?vue&type=style&index=0&id=1aa056f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa056f3",
  null
  
)

export default component.exports